import { render, staticRenderFns } from "./AssetCategory.vue?vue&type=template&id=12c01e7c&"
import script from "./AssetCategory.vue?vue&type=script&lang=js&"
export * from "./AssetCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports